<!-- CotizacionModal.vue -->
<template>
    <!-- Modal -->
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Información General</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="botonObjetivo"></button>
        </div>
        <div class="modal-body">
            <!--<div class="py-1 row" v-if="rol == 'Administrador' "> -->
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Folio:<span class="is-invalid">*</span> </label>
                    
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="folio" v-model="form.folio" required readonly/>
                    
                    <label class="is-invalid">{{validation.date}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Fecha de solicitud:<span class="is-invalid">*</span> </label>
                    
                   
                </div>
                <div class="col-md-9">
                    
                    <input type="date" class="form-control" id="razon_social" data-date-format="YYYY MM DD" v-model="form.fecha" required />
                    <label class="is-invalid">{{validation.fecha}}</label>
                </div>
                <!--<div class="col-md-1">
                    <label  for="name" >CIE:</label>
                    
                   
                </div>
                <div class="col-md-2">
                    
                    <input type="text" class="form-control" id="cie" v-model="form.cie" required />
                    <label class="is-invalid">{{validation.cie}}</label>
                </div>-->
            </div>
            <div class="py-1 row"> 
                <div class="col-md-3">
                    <label  for="name" >Nombre de proyecto: </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="nombre_proyecto" v-model="form.nombre_proyecto" required />
                    <label class="is-invalid">{{validation.nombre_proyecto}}</label>
                </div>
            </div>
            <div class="py-1 row"> 
                <div class="col-md-3">
                    <label  for="name" >Razón Social:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="razon_social" v-model="form.razon_social" required />
                    <label class="is-invalid">{{validation.razon_social}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Nombre del representante de la instalación:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="razon_social" v-model="form.nombre_representante" required />
                    <label class="is-invalid">{{validation.nombre_representante}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Email:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="email" class="form-control" id="email" v-model="form.email" required />
                    <label class="is-invalid">{{validation.email}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Inspector:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    
                    <select class="form-control" v-model="form.inspector" required>
                        <option></option>
                        <option :value="`${datos.name} ${datos.apellidos}`" v-for="datos  in datosinspectores">{{datos.name }} {{ datos.apellidos }}</option>
                    </select>
                    <label class="is-invalid"></label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Atención a:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="atn" v-model="form.atn" required />
                    <label class="is-invalid">{{validation.atn}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Gestionado por:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="gestionado_por" v-model="form.gestionado_por" required />
                    <label class="is-invalid">{{validation.gestionado_por}}</label>
                </div>
            </div>     
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Número de Visitas: </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" id="numero_visitas" v-model="form.numero_visitas" min="0" required />
                    <label class="is-invalid"></label>
                </div>
            </div> 
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Distancia: </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" v-model="form.distancia" min="0"  @blur="calcularViaticos"/>
                    <label class="is-invalid"></label>
                </div>
            </div> 
           
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Viaticos: </label>
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" id="viaticos" v-model="form.viaticos" min="0" @blur="calcularVisitaAdicional" required />
                    <label class="is-invalid"></label>
                </div>
            </div> 
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Costo visita adicional: </label>
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" id="visita_adicional"    v-model="form.visita_adicional" readonly  />
                    <label class="is-invalid"></label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Costo total: </label>
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" id="costo_total"    v-model="form.costo_total" readonly  />
                    <label class="is-invalid"></label>
                </div>
            </div>
             <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Otros Gastos: </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" v-model="form.otros_gastos" min="0"/>
                    <label class="is-invalid"></label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Dirección:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="text" class="form-control" id="direccion" v-model="form.direccion" required />
                    <label class="is-invalid">{{validation.direccion}}</label>
                </div>
            </div>
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Tipo: </label>
                   
                </div>
                <div class="col-md-9">
                    
                    <select class="form-control" id="tipo" v-model="form.tipo" required @click="consultarImporte">
                        <option value="Generación Distribuida - MT - kW">Generación Distribuida - MT - kW</option>
                        <option value="Centros de Carga Distribución - MT - kW">Centros de Carga Distribución - MT - kW</option>
                        <option value="Centros de Carga Transmisión - AT - MW">Centros de Carga Transmisión - AT - MW</option>
                        <option value="Centrales Eléctricas Distribución - MT - kW">Centrales Eléctricas Distribución - MT - kW</option>
                        <option value="Centrales Eléctricas Transmisión - AT - MW">Centrales Eléctricas Transmisión - AT - MW</option>
                        

                    </select>
                    <label class="is-invalid"></label>
                </div>
            </div>   
            
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Capacidad:<span class="is-invalid">*</span> </label>
                   
                </div>
                <div class="col-md-9">
                    <input type="number" class="form-control" id="capacidad" v-model="form.capacidad" required  min="1"  step="0.1" @keyup="consultarImporte"/>
                    <label class="is-invalid">{{validation.capacidad}}</label>
                </div>
            </div>  
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Unidad: </label>
                   
                </div>
                <div class="col-md-9">
                    <input class="form-control" v-model="form.unidad"   readonly/>
                    <!--<select class="form-control" id="unidad" v-model="form.unidad" required @click="consultarImporte">
                        <option value="Seleccionar">Seleccionar</option>
                        <option value="kW">kW</option>
                        <option value="MW">MW</option>
                    </select>-->
                    <label class="is-invalid"></label>
                </div>
            </div>   
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Importe: </label>
                   
                </div>
                <div class="col-md-9">
                    
                    <input type="text" class="form-control" id="importe" v-model="form.importeFor" required />
                    <label class="is-invalid"></label>
                </div>
            </div>   
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Voltaje de Conexión: </label>
                   
                </div>
                <div class="col-md-9">
                    
                    <select class="form-control" id="importe" v-model="form.voltaje_conexion" required >
                        <option value="Alta Tensión">Alta Tensión</option>
                        <option value="Media Tensión">Media Tensión</option>
                        <option value="Baja Tensión">Baja Tensión</option>
                       

                    </select>
                    <label class="is-invalid"></label>
                </div>
            </div>   
            <div class="py-1 row">
                <div class="col-md-3">
                    <label  for="name" >Oficio resolutivo CFE/CENACE: Tamaño máximo 5 MB</label>
                   
                </div>
                <div class="col-md-9">
                    <input type="file" class="form-control" @change="onFileChange" accept="application/pdf" />
                    <div v-if="file">
                    <h3>Vista previa del archivo:</h3>
                    <iframe :src="fileURL" width="100%" height="400"></iframe>
                    </div>
                    <!--<button v-if="file" @click="uploadFile">Subir Archivo</button>-->
                </div>
            </div>    
               
                
              
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="uploadFile">Guardar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="col-md-8">
        
    </div>
    <div class="col-md-12" style="text-align: right !important;">
        <button type="button" class="btn" style="background-color: #F49315; color: white;"  data-bs-toggle="modal" data-bs-target="#exampleModal" ref="consultarcotizacion" >
            Nuevo
        </button> &nbsp;
        <button type="button" class="btn " style="background-color: #F49315; color: white;"  @click="exportToExcel" >
            Reporte
        </button>
    </div>
    <br>
  </div>
  <h3 style="text-align: left;">Cotizaciones</h3><br>
  <div class="col-md-12 row"> 
    <!--<div class="col-md-4">
        <span>Inspector:</span>
        <select class="form-control">
            <option></option>
            <option :value="datos.name" v-for="datos  in datosinspectores">{{datos.name }}</option>
        </select>
    </div>
    <div class="col-md-4">
        <span>Buscar Columna:</span>
        <select class="form-control" v-model="searchField">
            <option value="folio">Folio</option>
            <option value="razon_social">Razon Social</option>
            <option value="nombre_representante">Representante</option> 
            <option value="tipo">Tipo</option>
            <option value="inspector">Inspector</option>
            <option value="capacidad">Capacidad</option>
            <option value="importe">Importe</option>
        </select>

        
    </div>-->
    <div class="col-md-4">
        <span>Buscar: </span>
        <input type="text" class="form-control" v-model="searchValue">
    </div>
  </div>
  <br>
  <EasyDataTable
    :headers="headers"
    :items="datoscotizaciones"
    
    :search-value="searchValue"
    :loading="loading"
    >
<template #item-operation="item">
    <div class="operation-wrapper">
      <!--<img
        src="./images/delete.png"
        class="operation-icon"
        @click="deleteItem(item)"
      />-->
      <!--<img
        src="./images/edit.png"
        class="operation-icon"
        @click="editItem(item)"
      />-->
      
      <button class="btn btn-light btn-sm" type="button" @click="showRow(item)"><span class="fa fa-eye" style="color:#F49315;"></span></button> &nbsp;
      <button class=" btn btn-light btn-sm" type="button" @click="generatePDF(item)"><span class="fa fa-file-pdf"></span></button> &nbsp;

      <button class="btn btn-light btn-sm" v-if="rol == 'Administrador' || 'Inspector' " type="button" @click="eliminar(item)"><span class="fa  fa-trash" style="color:red;"></span></button>
      
    </div>
  </template>
  </EasyDataTable>
  </template>
  
  <script>
  import * as XLSX from 'xlsx';
  import axios from 'axios';
  import "vue3-easy-data-table/dist/style.css";
  import Swal from 'sweetalert2';
  import { mapState, mapMutations } from 'vuex';
  export default {
    data() {
      return {
        loading:false,
        file: null,
        fileURL: null,
        rol: localStorage.getItem('userRoles'),
        searchField:[],
        searchValue:[],
        datoscotizaciones:[],
        show: false,
        enviando: false,
        form: {
            folio:' ',
            fecha:'',
            cie:'',
            razon_social: '',
            nombre_representante: '',
            email: '',
            inspector: '',
            numero_visitas: '',
            //tipo: 'Generación distribuida',
            direccion: '',
            capacidad: '',
            //unidad: 'Seleccionar',
            importe: '',
            voltaje_conexion: 'Alta Tensión',
            oficio_cfe: '',
            usuario :localStorage.getItem('email'),
            viaticos:0,
            distancia:0,
            costo_total:0,
            otros_gastos:0,
            gestionado_por:'',
            atn:''
        },
        validation:{
            folio:"",
            fecha:"",
            razon_social:"",
            nombre_representante:'',
            email:'',
            direccion:'',
            capacidad:'',
            gestionado_por:'',
            atn:''
        },
        headers:[],
        datosinspectores:[],
      };
    },
    created() {
        this.consultar();
        this.consultarInspector();
        this.folioConsultar();
        //this.consultarImporte();
    },
    computed: {
        
          ...mapState({
            isAuthenticated: state => state.auth.isAuthenticated,
            userRoles: state => state.auth.roles,
            //permisos: state => state.auth.permisos
          })
    },
    components: { 
      EasyDataTable: window["vue3-easy-data-table"]
    },
    methods: {
        calcularViaticos() {

            const km = parseFloat(this.form.distancia) || 0;

            let viaticos = 0;

            if (km <= 30) {
                viaticos = 0;
            } else if (km <= 120) {
                viaticos = km * 17;
            } else if (km <= 250) {
                viaticos = km * 19;
            } else if (km <= 400) {
                viaticos = km * 22;
            } else {
                const excedente = km - 400;
                viaticos = (400 * 22) + (excedente * 24);
            }

            this.form.viaticos = viaticos;
            this.form.visita_adicional = (viaticos * 0.70).toFixed(2);



              this.form.viaticos = parseFloat(this.form.viaticos) || 0;
            const numeroVisitas = parseInt(this.form.numero_visitas) || 0;
            const visitasAdicionales = Math.max(0, numeroVisitas - 2);

            const costoVisitasAdicionales = this.form.viaticos * 0.70 * visitasAdicionales;

            this.form.visita_adicional = costoVisitasAdicionales.toFixed(2);
            console.log((viaticos + costoVisitasAdicionales));
            this.form.costo_total = (viaticos + costoVisitasAdicionales);
        },
        /*calcularVisitaAdicional() {
            //alert(this.form.viaticos);
            this.form.visita_adicional = (parseFloat(this.form.viaticos) || 0) * 0.70;
        },*/
        /*calcularVisitaAdicional() {
            const viaticos = parseFloat(this.form.viaticos) || 0;
            const numeroVisitas = parseInt(this.form.numero_visitas) || 0;
            const visitasAdicionales = Math.max(0, numeroVisitas - 2);
            this.form.visita_adicional =
                (viaticos * 0.70 * visitasAdicionales).toFixed(2);
        },*/
        calcularVisitaAdicional() {
            const viaticos = parseFloat(this.form.viaticos) || 0;
            const numeroVisitas = parseInt(this.form.numero_visitas) || 0;
            const visitasAdicionales = Math.max(0, numeroVisitas - 2);

            const costoVisitasAdicionales = viaticos * 0.70 * visitasAdicionales;

            this.form.visita_adicional = costoVisitasAdicionales.toFixed(2);
            console.log((viaticos + costoVisitasAdicionales));
            this.form.costo_total = (viaticos + costoVisitasAdicionales);
        },
        folioConsultar(){
            
            axios.post(this.$rutaServer+'generarFolio')
            .then(response => {
              if (response.status == 200) {
                this.form.folio = response.data;
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
        },
        exportToExcel() {
            axios.post(this.$rutaServer+'reportecotizaciones')
            .then(response => {
              if (response.status == 200) {
                // Convertir datos a una hoja de trabajo
            const worksheet = XLSX.utils.json_to_sheet(response.data);
            
            // Crear un nuevo libro de trabajo y añadir la hoja de trabajo
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            
            // Generar archivo Excel y descargarlo
            XLSX.writeFile(workbook, `${'cotizaciones'}.xlsx`);
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
            
        },
        
        async uploadFile() {
            
            const formData = new FormData();
            if (!this.form.inspector) {
                    Swal.fire('¡Error!', 'Debe seleccionar un inspector.', 'error');
                    return;
            }
            if (!this.form.atn) {
                    Swal.fire('¡Error!', 'Debe llenar el campo Atención a.', 'error');
                    return;
            }
            if (!this.form.gestionado_por) {
                    Swal.fire('¡Error!', 'Debe llenar el campo Gestionado por.', 'error');
                    return;
            }
            if (this.enviando) return;
            this.enviando = true;
            formData.append('pdf', this.file);
            //formData.append('folio', this.form.folio);
            formData.append('fecha', this.form.fecha);
            //formData.append('cie', this.form.cie);
            formData.append('nombre_proyecto', this.form.nombre_proyecto);
            formData.append('razon_social', this.form.razon_social);
            formData.append('nombre_representante', this.form.nombre_representante);
            formData.append('email', this.form.email);
            formData.append('inspector', this.form.inspector);
            formData.append('numero_visitas', this.form.numero_visitas);
            formData.append('tipo', this.form.tipo);
            formData.append('direccion', this.form.direccion);
            formData.append('capacidad', this.form.capacidad);
            formData.append('unidad', this.form.unidad);
            formData.append('importe', this.form.importe);
            formData.append('voltaje_conexion', this.form.voltaje_conexion);
            formData.append('oficio_cfe', this.file);
            formData.append('usuario', localStorage.getItem('email'));
            formData.append('viaticos', this.form.viaticos);
            formData.append('visita_adicional', this.form.visita_adicional);
            formData.append('distancia', this.form.distancia);
            formData.append('otros_gastos', this.form.otros_gastos);
            formData.append('costo_total', this.form.costo_total);
            formData.append('atn', this.form.atn);
            formData.append('gestionado_por', this.form.gestionado_por);
            
            try {
                const response = await axios.post(this.$rutaServer+'cotizaciones', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                });
                if(response.status == 200){
                    this.$refs.botonObjetivo.click();
                    Swal.fire('¡Éxito!', 'Cotizacion almacenada', 'success');
                    this.consultar();
                    this.limpiarCampos();
                }
                 this.enviando = false;
                // Maneja la respuesta del servidor aquí
            } catch (error) {
            //console.log(error.response.data.errors.pdf[0]);
            if (error.response.data.errors) {
                // Asegúrate de que haya un error en el índice 0 del campo 'pdf'
                /*if (error.response.data.errors.pdf[0]) {
                    Swal.fire('¡Error!', 'El campo Oficio resolutivo no debería pesar más de 5 MB.', 'error');
                }*/
               if (error.response?.data?.errors?.pdf?.[0]) {
    Swal.fire(
        '¡Error!',
        'El campo Oficio resolutivo no debería pesar más de 5 MB.',
        'error'
    );
}
            } else {
                // Si no existe la estructura de error esperada
                alert(JSON.stringify(error.response.data));
            }
                //alert('Error al subir el archivo');
                // Maneja el error aquí
            }
            this.enviando = false;
        },
        async eliminar(item){
        const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: '¡Confirma eliminar la cotizacion!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                });
               
      if (result.isConfirmed) {
          axios.post(this.$rutaServer+'eliminarCotizacion', { id: item.id }, 
          {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`
            }
        })
            .then(response => {
                console.log(response);
              if (response.status == 200) {
                Swal.fire('¡Éxito!', 'Cotizacion eliminada', 'success');
                this.consultar();
              }
            })
            .catch(error => {
              Swal.fire('¡Error!', 'Ocurrió un error', 'error');
            });
          }
      },
        ...mapMutations(['setIsAuthenticated']),
        async generatePDF(item) {
      try {
        const dateObj = new Date(item.fecha);

        const day = dateObj.getDate().toString().padStart(2, '0');
            const month = dateObj.toLocaleString('es-ES', { month: 'long' });
            const year = dateObj.getFullYear();

            const formattedDate = `${day} de ${month} de ${year}`;
        var enviar = {
          idcotizacion : item.id,
          folio: item.folio,
          razon_social: item.razon_social,
          direccion: item.direccion,
          inspector: item.inspector,
          tipo: item.tipo,
          capacidad:item.capacidad +''+item.unidad,
          voltaje_conexion : item.voltaje_conexion,
          importe: item.importe,
          asignado:item.usuario,
          fecha:formattedDate,
          atn:item.atn,
          gestionado_por:item.gestionado_por
        };
        const response = await axios.post(this.$rutaServer+'generate-pdf',enviar, {
          responseType: 'blob' // Important for binary data
          
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', item.id+'.pdf'); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    },
    onFileChange(event) {
            if (!event?.target?.files || event.target.files.length === 0) {
        return;
    }
            const file = event.target.files[0];
            if (file && file.type === 'application/pdf') {
                this.file = file;
                this.fileURL = URL.createObjectURL(file);
            } else {
                alert('Por favor, seleccione un archivo PDF.');
            }
        },
        showRow(item){
            localStorage.removeItem('idcotizacion');
            localStorage.setItem('idcotizacion',item.id);
            this.$router.push('/mostrarcotizacion');

            /*this.form.nombre_representante = item.nombre_representante;
            this.form.razon_social = item.razon_social;
            this.form.email = item.email;
            this.form.inspector = item.inspector;
            this.form.capacidad = item.capacidad;
            this.form.direccion = item.direccion;
            this.form.importe = item.importe;
            this.form.numero_visitas = item.numero_visitas;
            this.form.tipo = item.tipo;
            this.form.unidad = item.unidad;
            this.form.usuario = item.usuario;
            this.$refs.consultarcotizacion.click();*/

        },
      openModal() {
        this.show = true;
      },
      closeModal() {
        this.show = false;
      },
      limpiarCampos(){
        this.validation.razon_social = '';
        this.validation.nombre_representante = '';
        this.validation.email = '';
        this.validation.capacidad = '';
        this.validation.direccion = '';
        this.form = '';
      },
      guardar() {
        console.log(this.form.capacidad);
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
        axios.post(this.$rutaServer+'cotizaciones', this.form)
          .then(response => {
            console.log(response.data);
            this.$refs.botonObjetivo.click();
            this.consultar();
            this.limpiarCampos();
            // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
          })
          .catch(error => {
            console.error('Error submitting form:', error);
            if(error.response.data.errors?.razon_social?.[0]){
                this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
            }
            if(error.response.data.errors?.nombre_representante?.[0]){
                this.validation.nombre_representante = error.response.data.errors?.nombre_representante?.[0];
            }
            if(error.response.data.errors?.email?.[0]){
                this.validation.email = error.response.data.errors?.email?.[0];
            }
            if(error.response.data.errors?.direccion?.[0]){
                this.validation.direccion = error.response.data.errors?.direccion?.[0];
            }
            if(error.response.data.errors?.capacidad?.[0]){
                this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
            }
          });
      }, 
      consultar(){
        this.loading = true;
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
        //axios.post('https://backsarei.seguridadeninspeccion.com/api/consultarCotizaciones')
        axios.post(this.$rutaServer+'consultarCotizaciones',{
            id: localStorage.getItem('id')
        })

          .then(response => {
            this.loading = false;
            //console.log(response.data);
            this.datoscotizaciones = response.data.data;
            this.datoscotizaciones = response.data.data.map(item => ({
        ...item,
        importeFormato: Number(item.importe).toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN'
        })
    }));
            this.headers = [
                        { text: "Folio", value: "folio", sortable: true },
                        { text: "Razon Social", value: "razon_social", sortable: true },
                        { text: "Representante", value: "nombre_representante", sortable: true },
                        { text: "Tipo", value: "tipo", sortable: true},
                        { text: "Asignado", value: "inspector", sortable: true}, 
                        { text: "Capacidad", value: "capacidad", sortable: true},
                        { text: "Importe", value: "importeFormato", sortable: true},
                        { text: "Operation", value: "operation", sortable: true}

                    ];
                    this.searchField  = ['folio','razon_social','nombre_representante','tipo','inspector','capacidad','importe'];
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      consultarInspector(){
        const token = localStorage.getItem('accessToken');
            const config = {
                headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
                }
            };
        //axios.post('https://backsarei.seguridadeninspeccion.com/api/consultarCotizaciones')
        axios.get(this.$rutaServer+'inspectores',config)

          .then(response => {
            //console.log(response.data);
            this.datosinspectores = response.data.data;
            
          })
          .catch(error => {
            console.error('Error submitting form:', error);
           
          });
      },
      limpiarCampos(){
        this.form.capacidad = '';
        this.form.importe = '';
        this.form.unidad = '';
        this.form.tipo = '';

      },
      consultarImporte(){
        //this.loading = true;
        //axios.post('https://backsarei.seguridadeninspeccion.com/api/consultarCotizaciones')
       
        if(this.form.tipo > ' ' && this.form.capacidad){
            console.log(this.form.tipo);
            console.log(this.form.capacidad);
            axios.post(this.$rutaServer+'calcular',{cantidad:this.form.capacidad,descripcion:this.form.tipo})

            .then(response => {
                //console.log(response.data);
                if(response.status == 200){
                    this.form.importe = response.data.importe;
                    this.form.importeFor = Number(response.data.importe).toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    });
                    this.form.unidad = response.data.unidad;
                    //this.loading = false;
                }
                
                
            })
            .catch(error => {
                console.error('Error submitting form:', error);
            
            });
        }
      }
    }
  };
  </script>
  
  <style>
  .is-invalid {
      color: red;
  }
</style>
  